import { Step } from '../../shared/components/Stepper/Stepper.types'

export const CREATE_EXTERNAL_FLIGHT_BOOKING_PAYMENT_INTENT_STORAGE_KEY = 'CREATE_EXTERNAL_FLIGHT_BOOKING_PAYMENT_INTENT'
export const ACCOUNT_SESSION_STORAGE_KEY = 'ACCOUNT_SESSION'
export const FLIGHT_ITINERARY_STORAGE_KEY = 'FLIGHT_ITINERARY'
export const DELIVERY_DETAILS_STORAGE_KEY = 'DELIVERY_DETAILS'

export const steps: Step[] = [
  { label: 'Review Trip Details' },
  { label: 'Delivery Details' },
  { label: 'Payout Details' },
  { label: 'Payment Details' },
  { label: 'Confirmation Complete' }
]

export const stepDetails = {
  reviewTripDetails: {
    headerTitle: steps[0].label,
    headerSubtitle: 'Review the details of your trip.',
    step: steps[0],
    index: 0
  },
  deliveryDetails: {
    headerTitle: steps[1].label,
    headerSubtitle:
      'Provide delivery address. Items will be delivered to this address x days before your flight to your destination.',
    step: steps[1],
    index: 1
  },
  setupStripeConnectAccount: {
    headerTitle: steps[2].label,
    headerSubtitle: 'Set up a payout that can be used to pay for your trips.',
    step: steps[2],
    index: 2
  },
  setupPaymentDetails: {
    headerTitle: steps[3].label,
    headerSubtitle: 'Set up a card that can be used to pay for your trips.',
    step: steps[3],
    index: 3
  },
  confirmationComplete: {
    headerTitle: steps[4].label,
    headerSubtitle: 'Your booking details have been confirmed.',
    step: steps[4],
    index: 4
  }
}
